<template>
	<div>
		<Header2022 :navbg='true'></Header2022>
		<div class="carport">
			<div class="spot-wrap">
				<iframe ref="iframe" :src="carportInfo.vr_url" frameborder="0"
					style="width: 100%;height: 100%;"></iframe>
			</div>
			<div class="business">
				<el-dropdown @command="handleCommand">
					<span class="el-dropdown-link">
						{{lan}}
						<img class="lanImg" :src="languagesList[index].image" mode="widthFix"></img>
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown" v-if="languagesList && languagesList.length>0">
						<el-dropdown-item v-for="(item,index) in languagesList" class="drawer-item" :key="index"
							:command="index">{{item.name}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="content" v-html="carportInfo.description_pc"></div>
		</div>
		<div class="btn-wrap">
			<el-button @click="gobuyTap(carportInfo.mall_url)">立即购买</el-button>
		</div>
		<Footer2022></Footer2022>
	</div>
</template>

<script>
	import Header2022 from '@/components/header2022.vue'
	import Footer2022 from '@/components/footer2022.vue'
	import {
		mapState
	} from 'vuex'

	export default {
		data() {
			return {
				languagesList: [],
				index: 0,
				lan: '简体中文',
				carportInfo:null,
			}
		},
		components: {
			Header2022,
			Footer2022,	
		},
		computed: {
			...mapState(['houseApi']),
		},
		created() {
			this.getMultilingualList();
		},
		methods: {
			getMultilingualList: function() {
				this.$axios.get(this.houseApi + 'languages')
					.then(res => {
						this.languagesList = res.data.data;
						this.getSeriesDetail();
					})
			},
			handleCommand(command) {
				this.index = command;
				this.lan = this.languagesList[command].name;
				this.getSeriesDetail();
			},
			getSeriesDetail: function() {
				this.$axios({
						method: 'get',
						url: this.houseApi + 'multilingue_product_pc_show',
						headers: {
							language: this.languagesList[this.index].code
						},
						params:{
							multilingue_tag: 1
						},
					})
					.then(res => {
						this.carportInfo = res.data;
					})
			},
			gobuyTap(url) {
				window.open(url);
			},
		},
	}
</script>
<style lang="scss">
	.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}
	.el-icon-arrow-down {
		font-size: 12px;
	}
	.btn-wrap {
		width: 100%;
		display: flex;
		justify-content: center;
		.el-button {
			font-size: 12px;
			text-align: center;
			cursor: pointer;
			width: 258px;
			height: 42px;
			border-radius: 20px;
			border:none;
			background: #222222;
			color: #FFFFFF;
		}
	}
	.carport {
		width: 100%;
		.spot-wrap {
			width: 100%;
			height: 100vh;
			background-size: 100% 100%;
			background-position: center center;
			
		}
		.business{
			font-size: 18px;
			position: fixed;
			top: 10%;
			color: #000000;
			right: 5%;
			text-align: center;
			background-color: #FFFFFF;
			display: flex;
			padding:5px 8px;
			align-items: center;
			justify-content: center;
		}
		.content{
			margin: 64px auto 0;
			max-width: 100%;
		}
	}
</style>